export interface LegalSection {
  title: string;
  body?: string[];
  items?: string[];
}

export const privacyPolicySections: LegalSection[] = [
  {
    title: "1. Information We Collect",
    body: ["We collect information when you use our mobile application and website."],
  },
  {
    title: "A. Personal Information You Provide",
    body: ["We collect information when you:"],
    items: [
      "Register an account",
      "Place an order",
      "Upload a profile photo",
      "Add delivery addresses",
      "Make a payment",
      "Contact customer support",
      "This may include name, mobile number, email address, delivery address, profile photo, and order details.",
    ],
  },
  {
    title: "B. Location Information",
    body: ["Our app may collect your precise location, with your permission, to:"],
    items: [
      "Identify and match the nearest serviceable delivery area",
      "Suggest nearby store options",
      "Improve delivery accuracy",
      "Location access is optional and can be disabled anytime in your device settings. We do not track your location in the background unless explicitly required and permitted.",
    ],
  },
  {
    title: "C. Camera & Storage Access",
    body: ["We request camera permission to allow profile photo capture and storage access to upload or select profile images."],
    items: [
      "These permissions are used only for the intended feature and not for any other purpose.",
    ],
  },
  {
    title: "D. Payment Information",
    body: [
      "We do not store your debit card, credit card, or wallet information on our servers.",
      "Online payments are securely processed by trusted third-party payment gateways. These providers handle your financial data according to their own privacy policies and security standards.",
    ],
  },
  {
    title: "E. Usage & Device Information",
    body: ["We may automatically collect:"],
    items: [
      "IP address",
      "Device type and model",
      "Operating system version",
      "App usage activity",
      "Crash logs",
      "This helps us improve performance, detect fraud, and enhance user experience.",
    ],
  },
  {
    title: "F. Push Notifications",
    body: ["We use push notifications to:"],
    items: [
      "Send order updates",
      "Notify offers and promotions",
      "Provide service-related alerts",
    ],
  },
  {
    title: "2. Third-Party Services",
    body: [
      "We may use trusted third-party services such as payment gateways, delivery partners, analytics providers, and Firebase Cloud Messaging for notifications.",
      "These services may collect limited technical information necessary to perform their functions.",
      "We do not sell your personal information to third parties.",
    ],
  },
  {
    title: "3. How We Use Your Information",
    items: [
      "Process and deliver orders",
      "Provide customer support",
      "Personalize offers",
      "Improve app performance",
      "Detect fraud and unauthorized transactions",
      "Comply with legal obligations",
    ],
  },
  {
    title: "4. Data Sharing",
    body: [
      "We may share your data with delivery partners for order fulfillment, payment processors, technical service providers, and legal authorities when required by law.",
      "Data is shared only as necessary for service operations.",
    ],
  },
  {
    title: "5. Data Security",
    body: [
      "We use industry-standard security measures such as encrypted connections (HTTPS), secure servers, and restricted internal access.",
      "However, no system can guarantee absolute security.",
    ],
  },
  {
    title: "6. Data Retention",
    body: [
      "We retain your personal information only as long as necessary to complete transactions, provide services, comply with legal obligations, and resolve disputes.",
      "After this period, data is securely deleted or anonymized.",
    ],
  },
  {
    title: "7. Your Rights",
    body: ["You may request:"],
    items: [
      "Access to your personal data",
      "Correction of inaccurate information",
      "Deletion of your account and data",
      "Withdrawal from marketing communications",
      "To exercise your rights, contact us using the details below.",
    ],
  },
  {
    title: "8. Updates to This Policy",
    body: [
      "We may update this Privacy Policy from time to time. The updated version will be posted on this page with a revised effective date.",
    ],
  },
  {
    title: "9. Contact Us",
    body: [
      "If you have any questions regarding this Privacy Policy or wish to exercise your rights, kindly contact us.",
    ],
  },
];

export const termsAndConditionsSections: LegalSection[] = [
  {
    title: "1. Acceptance of Terms",
    body: [
      "By accessing or using the Native App, website, or related services, you agree to these Terms and Conditions. If you do not agree, do not use the service.",
    ],
  },
  {
    title: "2. Use of Website",
    body: [
      "You agree to use the website, app, and services only for lawful business or personal purposes and in a way that does not disrupt, damage, misuse, or interfere with the service or other users.",
    ],
  },
  {
    title: "3. Product & Service Information",
    body: [
      "Product, pricing, subscription, delivery, and service information may change from time to time. We work to keep information accurate, but availability and service details may vary by account, branch, configuration, or location.",
    ],
  },
  {
    title: "4. Intellectual Property",
    body: [
      "All trademarks, logos, software, designs, text, graphics, and other materials in the website, app, and services belong to VasyERP Solutions Pvt. Ltd. or its licensors unless otherwise stated. You may not copy, modify, distribute, or reuse them without permission.",
    ],
  },
  {
    title: "5. Privacy",
    body: [
      "Use of the service is also governed by our Privacy Policy, which explains how information is collected, used, shared, and protected.",
    ],
  },
  {
    title: "6. Contact Information",
    body: [
      "For questions about these Terms and Conditions, contact VasyERP Solutions Pvt. Ltd. through the official support or contact channels.",
    ],
  },
];
